import React from 'react';
import PropTypes from 'prop-types';

export function InstructionBlock(props) {
  return <div className={props.className}>{props.children}</div>;
}

InstructionBlock.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * children components passed
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

InstructionBlock.defaultProps = {
  className: '',
};
